<template>
  <div ref="seccionPadresRef" class="seccion-invitacion-container">
    
    <!-- CAPA DE FONDO: MARIPOSAS ANIMADAS CON GSAP Y CSS -->
    <div class="mariposas-layer">
      <img 
        v-for="(mariposa, index) in mariposas" 
        :key="index"
        :ref="el => mariposaRefs[index] = el"
        src="@/assets/mariposa.png" 
        alt="Mariposa" 
        class="mariposa-img"
        :style="mariposa.estiloInicial"
      >
    </div>

    <div class="overlay-padres">
      
      <!-- SECCIÓN DECORATIVA SUPERIOR: Corona y Moño -->
      <div ref="graphicsHeaderRef" class="header-graphics-wrapper">
        
        <!-- Contenedor del moño corregido y perfectamente centrado -->
        <div class="monio-full-width-wrapper">
          <img 
            src="@/assets/monio.png" 
            alt="Moño Rojo" 
            class="monio-header-img"
          >
        </div>
      </div>

      <!-- 🎭 MÁSCARA COLOCADA ABAJO DEL MOÑO (SEGUNDO LUGAR EN LA SECUENCIA) -->
      <div ref="mascaraWrapperRef" class="mascara-sub-monio-wrapper">
        <img 
          src="@/assets/coronaa.png" 
          alt="Máscara Antifaz" 
          class="mascara-sub-monio-img"
        >
      </div>

      <!-- SECCIÓN TEXTO EMOCIONAL -->
      <div ref="textoPoemaRef" class="texto-poema-container">
        <p class="poema-linea">
          Hay momentos inolvidables que se atesoran en el corazón para siempre, 
          por esa razón me gustaría que compartas conmigo este día tan especial:<br><br>
        </p>
        <h2 class="mis-xv-title">Mis<span class="letra-especial1"> XV    años</span></h2>
        <p class="bendicion-linea"><br>
          Acompañanos a celebrar con la bendición de Dios y de mis padres:
        </p>
      </div>

      <!-- SECCIÓN PADRES -->
      <div ref="padresContainerRef" class="padres-container">
        <div class="nombre-padre">Beatriz Berumen</div>
        <div class="ampersand">&</div>
        <div class="nombre-padre">Guillermo Buenrostro</div>
      </div>

 <!-- SECCIÓN PADRINOS -->
<div ref="padrinosContainerRef" class="padrinos-container">
  <h3 class="titulo-padrinos">Mis Padrinos:</h3><br>

  <div class="nombre-padrino">
Paola Osuna<span class="letra-especial"></span>
  </div>

  <div class="ampersand"></div>

  <div class="nombre-padrino">
    Diana Osuna<span class="letra-especial"></span>
  </div>
    <div class="nombre-padrino">
    Clementina Solis<span class="letra-especial"></span>
  </div>
</div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'SeccionPadresPadrinos',
  setup() {
    const seccionPadresRef = ref(null)
    const graphicsHeaderRef = ref(null)
    const mascaraWrapperRef = ref(null)
    const textoPoemaRef = ref(null)
    const padresContainerRef = ref(null)
    const padrinosContainerRef = ref(null)
    
    const mariposaRefs = ref([])

    // Configuración inicial de posiciones para no saturar la pantalla
    const mariposas = [
      { estiloInicial: { top: '0%', left: '6%', width: '68px' } },
      { estiloInicial: { top: '25%', right: '4%', width: '65px' } },
      { estiloInicial: { top: '65%', left: '4%', width: '60px' } },
      { estiloInicial: { top: '78%', right: '6%', width: '66px' } }
    ]

    onMounted(() => {
      // 1. TIMELINE DE CONTENIDO PRINCIPAL CON SECUENCIA CONSECUTIVA
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: seccionPadresRef.value,
          start: 'top 75%',
          toggleActions: 'play none none none'
        }
      })

      // Paso 1: Entran Corona y Moño
      tl.from(graphicsHeaderRef.value, {
        opacity: 0,
        y: -35,
        scale: 0.95,
        duration: 1.1,
        ease: 'power2.out'
      })
      
      // Paso 2: Entra inmediatamente la Máscara debajo del moño
      .from(mascaraWrapperRef.value, {
        opacity: 0,
        y: -20,
        scale: 0.8,
        duration: 0.8,
        ease: 'back.out(1.5)'
      }, '-=0.4')

      // Paso 3: Continúa el Poema
      .from(textoPoemaRef.value, {
        opacity: 0,
        y: 30,
        duration: 0.9,
        ease: 'power3.out'
      }, '-=0.4')

      // Paso 4: Padres
      .from(padresContainerRef.value, {
        opacity: 0,
        scale: 0.9,
        y: 25,
        duration: 1,
        ease: 'back.out(1.4)'
      }, '-=0.4')

      // Paso 5: Padrinos
      .from(padrinosContainerRef.value, {
        opacity: 0,
        y: 30,
        duration: 0.9,
        ease: 'power3.out'
      }, '-=0.5')

      // 2. ANIMACIÓN DE FLOTACIÓN SUTIL DE MARIPOSAS
      mariposaRefs.value.forEach((el, index) => {
        if (!el) return
        gsap.to(el, {
          y: '+=18',
          x: index % 2 === 0 ? '+=10' : '-=10',
          rotation: index % 2 === 0 ? 8 : -8,
          duration: 3 + index * 0.7,
          repeat: -1,
          yoyo: true,
          ease: 'sine.easeInOut'
        })
      })
    })

    return {
      seccionPadresRef,
      graphicsHeaderRef,
      mascaraWrapperRef,
      textoPoemaRef,
      padresContainerRef,
      padrinosContainerRef,
      mariposaRefs,
      mariposas
    }
  }
}
</script>
<style scoped>
/* ==========================================
   1. CONTENEDOR PRINCIPAL
   ========================================== */
.seccion-invitacion-container {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  overflow: hidden;
  margin-top:-50px;
  padding-bottom: 60px;
}

.overlay-padres {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 2;
}

/* ==========================================
   2. CORONA Y MOÑO (CORREGIDO Y CENTRADO)
   ========================================== */
.header-graphics-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-bottom: 25px;
  position: relative;
}

.corona-img {
  width: 120px;
  height: auto;
  margin-bottom: -50px;
  z-index: 5;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.12));
}

/* Envoltorio para garantizar que el moño se extienda sin desfasarse a la izquierda */
.monio-full-width-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.monio-header-img {
  width: 100%;
  min-width: 100%;
  max-width: none; /* Asegura que cubra el ancho entero sin desplazamientos */
  height: auto;
  display: block;
  object-fit: cover;
}

/* ==========================================
   3. TEXTO Y CONTENIDO
   ========================================== */
.texto-poema-container {
  text-align: center;
  margin: 0 auto 25px;
  padding: 0 24px;
  max-width: 550px;
  box-sizing: border-box;
}

.poema-linea {
  font-family: 'Playfair Display', serif;
  font-size: 15px;
  line-height: 1.6;
  color: #6E5336;
  font-style: italic;
  margin-bottom: 12px;
}

.mis-xv-title {
  font-family: 'ludovica', serif;
  font-size: 44px;
  color: #8C1C29;
  font-weight: 500;
  padding-right: 9px !important;
  margin: 10px 0;
  line-height: 1;
}

.bendicion-linea {
  font-family: 'Playfair Display', serif;
  font-size: 15px;
  line-height: 1.5;
  color: #B08D57;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
}

/* ==========================================
   4. PADRES Y PADRINOS
   ========================================== */
.padres-container,
.padrinos-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  text-align: center;
  padding: 0 20px;
  box-sizing: border-box;
}

.padres-container {
  margin-bottom: 35px;
}

.titulo-padrinos {
  font-family: 'Playfair Display', serif;
  font-size: 14px;
  color: #B08D57;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 10px;
}

.nombre-padre,
.nombre-padrino {
  font-family: 'ludovica', serif;
  font-size: 36px;
  color: #B08D57;
  font-weight: 500;
  line-height: 1.5;
}

.ampersand {
  font-family: 'Playfair Display', serif;
  font-size: 22px;
  color: #8C1C29;
  margin: 2px 0;
  font-style: italic;
}
.letra-especial1 {
  font-family: 'Great Vibes', cursive;
}
.letra-especial {
  font-family: 'Great Vibes', cursive;
}
/* ==========================================
   5. CAPA DE MARIPOSAS DE FONDO
   ========================================== */
.mariposas-layer {
  position: absolute;
  top: 
  0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
}

.mariposa-img {
  position: absolute;
  height: auto;
  opacity: 1;
  /* Aleteo CSS sutil en el eje Y/Z para renderizado fluido */
  animation: aleteoSutil 1.8s infinite ease-in-out alternate;
  will-change: transform;
}

@keyframes aleteoSutil {
  0% {
    transform: scaleX(1);
  }
  100% {
    transform: scaleX(0.65);
  }
}

/* ==========================================
   3. ESTILOS DE LA MÁSCARA ABAJO DEL MOÑO
   ========================================== */
.mascara-sub-monio-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: -85px;
  margin-bottom: 30px;
  z-index: 4;
}

.mascara-sub-monio-img {
  width: 240px;
  height: auto;
  filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.15));
}
</style>